import React from "react";
import styles from "./Brand.module.scss";
import { Icon } from "../../atoms/Icon";
import { useBrandPage } from "./hooks";
import { Spinner } from "@blueprintjs/core";
import useAuthState from "../../hooks/useAuthState";
import AffiliatePage from "../../layouts/AffiliatePage/AffiliatePage";
import { NotFound } from "../Error";
import className from "classnames";

export default function Brand({ match, history }) {
  const {
    params: { username }
  } = match;
  const { isLoggedIn } = useAuthState();
  const {
    account,
    preference,
    programFeatures,
    opportunities,
    loading
  } = useBrandPage({
    username
  });

  if (loading) {
    return (
      <div className={styles.centered}>
        <Spinner />
      </div>
    );
  }

  if (!loading && !account) {
    return <NotFound />;
  }

  const { name, bio } = account || {};

  const { backgroundColor, backgroundImage, brandLogo, programHighlight } =
    preference || {};

  return (
    <AffiliatePage
      title={name}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      brandName={username}
    >
      <div className={"container"}>
        <div className={styles.detailOutlet}>
          <div className={styles.brandRow}>
            <div className={styles.getStarted}>
              <h1>Enjoy With Us.</h1>
              <h1> Enjoy the Perks.</h1>
              <p>
                Do what you love: create content that people love And earn while
                you do it. It's that simple!
              </p>
              {!isLoggedIn && (
                <button
                  className={styles.pinkButton}
                  onClick={() => history.push("/register")}
                >
                  Get Started
                </button>
              )}
            </div>
            <div className={styles.detailBox}>
              <div className={styles.brandPicture}>
                <img alt={name} src={brandLogo} />
              </div>
              <h5>{name}</h5>
              <p>{bio}</p>
            </div>
          </div>

          {!isLoggedIn ? (
            <div className={styles.programRow}>
              <div
                className={className(
                  styles.programHighlights,
                  programFeatures.length > 0 ? "text-left" : ""
                )}
              >
                <h2>Program Highlights</h2>
                <p>{programHighlight}</p>
                <button
                  className={styles.pinkButton}
                  onClick={() => history.push("/register")}
                >
                  Join Now
                </button>
              </div>
              <div className={styles.programFeatures}>
                <ul className={styles.checkListItems}>
                  {programFeatures.map((feature) => (
                    <li>
                      <Icon name="tick-circle" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <div className={styles.productRow}>
              <h2>Products</h2>
              <div className={styles.productList}>
                {opportunities.map((opportunity) => (
                  <div
                    className={styles.product}
                    onClick={() =>
                      history.push(`/share/opportunity/${opportunity.id}`)
                    }
                  >
                    <img src={opportunity.product.images[0].url} />
                    <h3>{opportunity.product.name}</h3>
                    <span>
                      {opportunity.product.isDonation
                        ? "Donation"
                        : `$${parseFloat(
                            opportunity.product.price || 0
                          ).toFixed(2)}`}
                    </span>
                    <p>{opportunity.product.description}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </AffiliatePage>
  );
}
